// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2Aarp","abort":"style_abort__3vn6C","register":"style_register__3oT_C"};